import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import AstarPlan from '../views/AstarPlan.vue'
import NewsCenter from '../views/NewsCenter.vue'
import JoinUs from '../views/JoinUs.vue'
import consult from '../views/consult.vue'
import dynamics from '../views/dynamics.vue'
import brandDetail from '../views/brandDetail.vue'
import supplierDetail from '../views/supplierDetail.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView
  },
  {
    path: '/astarPlan',
    name: 'astarPlan',
    component: AstarPlan
  },
  {
    path: '/newsCenter',
    name: 'newsCenter',
    component: NewsCenter,
    meta: {  keepAlive: true },
  },
  {
    path: '/joinUs',
    name: 'joinUs',
    component: JoinUs
  },
  {
    path: '/consult',
    name: 'consult',
    component: consult
  },
  {
    path: '/dynamics',
    name: 'dynamics',
    component: dynamics
  },
  {
    path: '/brandDetail',
    name: 'brandDetail',
    component: brandDetail
  },
  {
    path: '/supplierDetail',
    name: 'supplierDetail',
    component: supplierDetail
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
})

const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


export default router
